import styled, { keyframes } from "styled-components";
import { WrapperContainer } from "../../components";
import { colors } from "../../consts";

const GradientLoaderAnimation = keyframes`
  0% {
		background-position: 0 0;
	}
	100% {
		background-position: 100em 0;
	}
`;

export const GradientLoaderStyled = styled(WrapperContainer)`
  border-radius: ${(props) => `${props.borderRadius}px`};
  background: ${colors.RAISIN_20};

  /* background: linear-gradient(90deg, #ebeaec, #d6d6d8, #ebeaec);
  animation-name: ${GradientLoaderAnimation};

  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-duration: ${(props) => `${props.animationDuration}s`}; */
`;
